/*========================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["jquery", "underscore", "utils/keys", "utils/dom"], function ($, _, keys, dom) {

  return {

    update: function ($el, e) {
      var that = this;

      $el.on("keydown.mb-role-dialog", function (e) {
        var el = e.target,
            $focusable,
            currentIndex,
            handle = false;

        if (e.which === keys.tab) {
          $focusable = $el.find(dom.getFocusableSelector(true));
          currentIndex = $focusable.index(e.target);
          if (currentIndex < 0) currentIndex = 0;

          if (e.shiftKey) {
            currentIndex--;
          } else {
            currentIndex++;
          }

          if (currentIndex < 0) {
            handle = true;
            currentIndex = $focusable.length - 1;
          }
          if (currentIndex >= $focusable.length) {
            handle = true;
            currentIndex = 0;
          }

          if (handle) {
            $focusable[currentIndex].focus();
            e.preventDefault();
          }
        }
      });
    },

    destroy: function () {
      this.$el && this.$el.off(".mb-role-dialog");
    }
  };

});
